import styled from "styled-components";
import { ComponentStack } from "@components";

export const DotsComponentStack = styled(ComponentStack)`
  justify-content: center;
`;
